import { Component, HostListener, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ModalOptionsConfig, ModalService } from '../nz-modal-service/modal.service';
import { YearlyReviewReportModalComponent } from './yearly-review-report-modal/yearly-review-report-modal.component';

@Component({
	selector: 'app-yearly-review-banner',
	templateUrl: './yearly-review-banner.component.html',
	styleUrls: ['./yearly-review-banner.component.scss'],
})
export class YearlyReviewBannerComponent implements OnInit {
	isMobile: boolean;
	breakPoint = 900;
	runningModal: NzModalRef;

	constructor(public modal: ModalService) {}

	ngOnInit(): void {
		this.setMobile(window.innerWidth);
	}

	@HostListener('window:resize', ['$event'])
	onResize(event): void {
		this.setMobile(window.innerWidth);
	}

	setMobile(browserWidth: number) {
		this.isMobile = browserWidth <= this.breakPoint;
	}

	showYearlyReviewModal() {
		const config = this.createModalConfig();
		this.runningModal = this.modal.createModal(YearlyReviewReportModalComponent, config);
	}

	createModalConfig(data?) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.data = data;
		// config.className = "moniepoint-dialog"
		config.nzMaskClosable = true;
		config.hideNZTitle = true;
		config.nzClosable = true;
		config.nzComponentParams.callback = (result) => {};
		return config;
	}
}
